(() => {
  if (window.AndCharlieProductDescriptionToggleInitialized) return;
  window.AndCharlieProductDescriptionToggleInitialized = true;

  // A delegated listener also handles Dawn product swaps and Theme Editor section replacement.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.ac-product-description-toggle__button');
    const container = button?.closest('.ac-product-description-toggle');
    if (!container) return;

    const short = container.querySelector('.ac-product-description-toggle__short');
    const full = container.querySelector('.ac-product-description-toggle__full');
    if (!full) return;

    const isOpen = button.getAttribute('aria-expanded') === 'true';
    if (short) short.hidden = !isOpen;
    full.hidden = isOpen;
    button.setAttribute('aria-expanded', String(!isOpen));
    button.textContent = isOpen ? '続きを読む' : '閉じる';
  });
})();
